import React from 'react';

const InputFeedback = ({ error }) => (error ? <div className="invalid-feedback mb-3">{error}</div> : null);

export default InputFeedback;